/* tslint:disable:indent */
import {FormGroup} from '@angular/forms';

export class FormInput {
  name: string;
  formGroup: FormGroup;
  type: string;
  index: number;
  sepSep:  string;
  elements: string[];
  repeatablePathWithIndex : string;

  constructor() {
  }
}
